export class ReelsStripConfig {
    public static readonly REELS_SYMBOLS_INDEX: number = 28000

    public static readonly NORMAL_GAME_SYMBOLS_STRIP: number[][] = [
        [
            8, 6, 6, 7, 9, 8, 10, 6, 8, 3,
            6, 11, 9, 3, 8, 4, 4, 4, 10, 6,
            3, 2, 8, 10, 11, 4, 10, 4, 6, 11,
            4, 2, 8, 11, 3, 3, 3, 3,
            3, 9, 4, 8, 11, 8, 2, 4, 10, 10,
            10, 4, 4, 4, 11, 11, 11, 3, 3, 8,
            8, 6, 10, 8, 6, 3, 11, 10, 3, 2,
            4, 10, 8, 11, 10, 4, 8, 3, 11, 10,
            7, 4, 10, 8, 8, 8, 3 , 2, 10, 4,
            11, 10, 3, 3, 10, 4, 3, 4, 10, 2,
            4, 10, 8, 4, 3, 10, 6, 4, 10,
            6, 6, 10, 9, 2, 6, 4, 8, 8, 4,
            6, 10, 9, 8, 10, 2, 8, 10, 8, 6,
            6, 2, 10, 9, 8, 10, 9, 8, 10,
            6, 6, 8, 10, 10, 10, 9, 8, 10, 3,
            3, 3, 8, 10, 7, 8, 10, 6, 8, 6,
            10, 8, 2, 6, 8, 10, 6, 2, 8, 10,
            6, 6, 9, 8, 10, 10, 10, 8, 8,
        ],
        [
            1, 1, 1, 5, 7, 8, 6, 7, 9, 7,
            5, 11, 9, 1, 3, 9, 5, 7, 11, 5,
            7, 9, 8, 5, 11, 3, 3, 9, 1, 5,
            9, 9, 4, 1, 8, 4, 5, 9, 4, 5,
            5, 5, 7, 9, 11, 4, 6, 11, 9, 5,
            5, 4, 11, 7, 9, 9, 9, 9, 5, 5,
            3, 3, 5, 10, 3, 7, 5, 6, 3, 1,
            10, 9, 7, 8, 3, 5, 11, 10, 9, 7,
            3, 5, 11, 4, 7, 10, 4, 5, 3, 7,
            10, 4, 11, 3, 3, 9, 9, 11, 9, 3,
            4, 11, 3, 6, 7, 7, 7, 4, 1, 4,
            4, 4, 4, 9, 9, 9, 8, 10, 7, 4,
            8, 10, 1, 8, 9, 4, 10, 9, 9, 10,
            4, 9, 4, 9, 8, 3, 3, 10, 7, 7,
            7, 9, 9, 10, 3, 9, 7, 7, 10, 9,
            8, 4, 10, 9, 7, 10, 9, 7, 7, 10,
            9, 9, 9, 8, 10, 4, 9, 7, 7, 10, 10
        ],
        [
            1, 1, 1, 4, 8, 6, 9, 6, 6, 4,
            7, 7, 4, 10, 2, 9, 6, 4, 4, 6,
            3, 4, 3, 3, 11, 10, 4, 2, 4, 10,
            8, 11, 11, 11, 4, 4, 2, 4, 9, 11,
            2, 4, 4, 11, 2, 9, 9, 6, 6, 6,
            4, 11, 1, 9, 10, 6, 11, 8, 10, 4,
            4, 11, 4, 5, 9, 8, 2, 11, 6, 6,
            6, 11, 3, 3, 3, 10, 4, 9, 9, 11,
            11, 3, 4, 6, 11, 3, 6, 11, 3, 6,
            6, 4, 1, 7, 8, 7, 8, 2, 1, 4,
            9, 6, 10, 3, 7, 4, 2, 3, 3, 3,
            8, 4, 4, 4, 2, 10, 9, 3, 3, 1,
            9, 2, 10, 8, 6, 10, 9, 6, 7, 10,
            9, 9, 8, 2, 10, 3, 3, 10, 6, 6,
            7, 10, 8, 3, 10, 6, 8, 9, 10, 9,
            7, 8, 10, 6, 7, 8, 4, 9, 10, 6,
            4, 10, 7, 7, 7, 6, 6, 8, 10,
        ],
        [
            1, 1, 11, 7, 8, 9, 6, 9, 11, 5,
            5, 5, 3, 3, 3, 8, 11, 8, 9, 9,
            7, 11, 8, 9, 8, 3, 3, 3, 7, 8,
            6, 4, 4, 4, 6, 3, 11, 10, 9, 8,
            1, 3, 3, 11, 3, 11, 3, 5, 5, 5,
            4, 11, 4, 6, 11, 7, 8, 10, 6, 6,
            6, 4, 11, 4, 10, 7, 3, 11, 3, 8,
            10, 10, 9, 10, 8, 4, 2, 4, 9, 6,
            6, 3, 11, 3, 6, 4, 11, 4, 7, 3,
            3, 7, 11, 9, 8, 8, 6, 3, 11, 3,
            3, 6, 6, 7, 11, 8, 4, 4, 4, 4,
            4, 4, 10, 9, 7, 8, 8, 6, 3, 4,
            4, 4, 3, 3, 7, 8, 8, 6, 6, 6,
            7, 7, 7, 6, 6, 6, 7, 7, 8, 6,
            6, 6, 6, 8, 4, 4, 4, 7, 8, 8, 10
        ],
        [
            11, 9, 4, 10, 10, 8, 7, 9, 3, 11,
            9, 4, 4, 3, 2, 7, 3, 3, 9, 4,
            11, 9, 6, 11, 9, 6, 2, 3, 3, 3,
            8, 8, 7, 4, 11, 10, 3, 11, 9, 9,
            9, 2, 8, 9, 5, 8, 7, 2, 9, 8,
            10, 9, 9, 2, 4, 10, 4, 4, 6, 7,
            9, 10, 11, 11, 11, 8, 9, 6, 7, 9,
            8, 3, 3, 3, 8, 4, 4, 4, 10, 6,
            7, 8, 10, 10, 10, 6, 3, 4, 3, 7,
            8, 2, 11, 11, 11, 4, 4, 4, 4, 3,
            3, 3, 2, 9, 4, 4, 5, 10, 10, 2,
            7, 8, 10, 8, 3, 3, 4, 2, 7, 10,
            7, 8, 9, 4, 10, 9, 7, 5, 8, 8,
            10, 10, 2, 4, 4, 3, 3, 3, 4, 6,
            10, 8, 8, 10, 10, 10, 6, 7, 9, 10,
            10, 8, 7, 8, 3, 9, 7, 3, 3, 3,
            9, 9, 6, 5, 11, 11, 11, 9, 9, 2,
            3, 3, 3, 8, 8, 7, 4, 4, 4, 11,
            11, 11, 9, 9, 9, 2, 8, 9, 8, 7,
            2, 9, 8, 10, 9, 9, 2, 4, 4, 4,
            6, 7, 10, 9, 10, 11, 11, 11, 8, 9,
            6, 7, 9, 9, 3, 3, 3, 8, 4, 4,
            4, 10, 6, 7, 8, 10, 10, 10, 6, 3,
            3, 3, 7, 8, 11, 11, 11, 4, 4, 4,
            3, 3, 3, 9, 10, 4, 4, 4, 10, 10,
            7, 8, 10, 8, 3, 3, 7, 10, 7, 8,
            9, 10, 9, 7, 8, 8, 10, 10, 4, 4,
            3, 3, 3, 4, 6, 10, 8, 8, 10, 10,
            10, 6, 7,
        ],
        [
            11, 9, 4, 10, 10, 8, 7, 9, 3, 11,
            9, 4, 4, 3, 2, 7, 3, 3, 9, 4,
            11, 9, 6, 11, 9, 6, 2, 3, 3, 3,
            8, 8, 7, 4, 11, 10, 3, 11, 9, 9,
            9, 2, 8, 9, 5, 8, 7, 2, 9, 8,
            10, 9, 9, 2, 4, 10, 4, 4, 6, 7,
            9, 10, 11, 11, 11, 8, 9, 6, 7, 9,
            8, 3, 3, 3, 8, 4, 4, 4, 10, 6,
            7, 8, 10, 10, 10, 6, 3, 4, 3, 7,
            8, 2, 11, 11, 11, 4, 4, 4, 4, 3,
            3, 3, 2, 9, 4, 4, 5, 10, 10, 2,
            7, 8, 10, 8, 3, 3, 4, 2, 7, 10,
            7, 8, 9, 4, 10, 9, 7, 5, 8, 8,
            10, 10, 2, 4, 4, 3, 3, 3, 4, 6,
            10, 8, 8, 10, 10, 10, 6, 7, 9, 10,
            10, 8, 7, 8, 3, 9, 7, 3, 3, 3,
            9, 9, 6, 5, 11, 11, 11, 9, 9, 2,
            3, 3, 3, 8, 8, 7, 4, 4, 4, 11,
            11, 11, 9, 9, 9, 2, 8, 9, 8, 7,
            2, 9, 8, 10, 9, 9, 2, 4, 4, 4,
            6, 7, 10, 9, 10, 11, 11, 11, 8, 9,
            6, 7, 9, 9, 3, 3, 3, 8, 4, 4,
            4, 10, 6, 7, 8, 10, 10, 10, 6, 3,
            3, 3, 7, 8, 11, 11, 11, 4, 4, 4,
            3, 3, 3, 9, 10, 4, 4, 4, 10, 10,
            7, 8, 10, 8, 3, 3, 7, 10, 7, 8,
            9, 10, 9, 7, 8, 8, 10, 10, 4, 4,
            3, 3, 3, 4, 6, 10, 8, 8, 10, 10,
            10, 6, 7,
        ]
    ]

    public static readonly FREE_GAME_SYMBOLS_STRIP: number[][] = [
        [
            8, 6, 7, 9, 8, 14, 8, 3, 3, 3,
            3, 4, 4, 3, 10, 6, 11, 4, 10, 4,
            6, 11, 4, 2, 11, 6, 3, 13, 3, 3,
            3, 3, 4, 4, 8, 11, 6, 12, 2, 6,
            10, 10, 4, 6, 4, 11, 11, 11, 8, 8,
            6, 3, 3, 3, 2, 10, 10, 10, 8, 11,
            11, 11, 4, 4, 4, 8, 7, 8, 13, 8,
            2, 10, 10, 10, 3, 3, 4, 4, 4, 3,
            4, 4, 4, 8, 3, 10, 10, 10, 12, 3,
            3, 3, 6, 6, 6, 8, 8, 10, 10, 10,
            10, 8, 8, 6, 6, 6, 9, 9, 8, 10,
            10, 10, 6, 6, 6, 8, 10, 10, 3, 3,
            3, 3, 8, 10, 10, 2, 10, 8, 8, 8,
            8, 2, 6, 6, 6, 6, 10, 10, 10, 8,
            8, 10, 10, 8, 8, 10, 8, 2, 6, 6,
            6, 9, 10, 10, 10, 8, 8
        ],
        [
            1, 1, 1, 8, 6, 7, 9, 13, 7, 7,
            7, 9, 11, 1, 1, 1, 11, 11, 7, 1,
            9, 8, 1, 1, 1, 9, 12, 1, 3, 3,
            11, 1, 9, 9, 8, 9, 1, 4, 6, 11,
            9, 6, 1, 11, 11, 11, 6, 12, 1, 1,
            9, 9, 9, 6, 6, 11, 11, 11, 1, 9,
            9, 14, 9, 11, 11, 11, 4, 4, 4, 3,
            3, 3, 7, 11, 11, 11, 6, 1, 1, 1,
            8, 3, 13, 3, 10, 9, 7, 3, 9, 4,
            4, 7, 1, 1, 1, 7, 10, 4, 9, 3,
            3, 3, 1, 1, 1, 3, 9, 9, 10, 9,
            3, 3, 3, 3, 7, 7, 1, 1, 1, 4,
            4, 4, 6, 9, 9, 9, 9, 1, 1, 7,
            4, 4, 8, 10, 6, 9, 9, 10, 9, 9,
            9, 8, 3, 3, 3, 10, 1, 1, 1, 9,
            9, 10, 3, 3, 3, 3, 9, 7, 7, 1,
            10, 9, 9, 9, 4, 4, 4, 1, 1, 1,
            10, 7, 7, 7, 10, 9, 9, 9, 8, 10,
            10, 7, 7, 10, 10,
        ],
        [
            1, 1, 1, 8, 12, 6, 7, 7, 2, 9,
            6, 4, 1, 1, 1, 4, 4, 4, 6, 3,
            3, 3, 6, 11, 4, 10, 10, 8, 11, 11,
            6, 1, 13, 1, 4, 4, 4, 4, 6, 9,
            2, 1, 1, 1, 11, 4, 4, 4, 11, 9,
            9, 6, 6, 6, 2, 11, 11, 11, 12, 9,
            10, 6, 13, 10, 4, 4, 4, 9, 9, 8,
            2, 1, 1, 1, 6, 6, 6, 3, 3, 3,
            10, 9, 9, 11, 11, 11, 3, 3, 3, 4,
            4, 4, 6, 6, 14, 6, 7, 7, 7, 8,
            10, 1, 1, 1, 9, 6, 10, 3, 7, 4,
            1, 1, 1, 6, 4, 3, 8, 4, 4, 6,
            10, 9, 3, 3, 9, 10, 8, 9, 1, 2,
            9, 9, 3, 3, 3, 3, 6, 6, 6, 7,
            2, 8, 3, 3, 3, 3, 9, 10, 9, 7,
            8, 10, 6, 7, 8, 9, 1, 10, 6, 10,
            2, 4, 4, 4, 7, 7, 7, 6, 10, 10,
            6, 6, 10, 8, 10,
        ],
        [
            1, 1, 1, 7, 8, 9, 6, 9, 9, 11,
            11, 11, 3, 3, 1, 12, 1, 3, 8, 8,
            8, 9, 6, 1, 1, 1, 7, 7, 8, 9,
            3, 3, 3, 1, 1, 1, 8, 6, 1, 4,
            4, 13, 10, 9, 1, 8, 6, 3, 3, 3,
            1, 14, 1, 3, 3, 3, 11, 11, 11, 4,
            4, 4, 6, 7, 7, 8, 10, 6, 6, 6,
            4, 4, 4, 1, 1, 1, 3, 3, 8, 10,
            10, 9, 12, 1, 1, 4, 4, 9, 6, 6,
            3, 3, 3, 6, 4, 4, 4, 13, 1, 1,
            7, 9, 9, 8, 8, 4, 3, 3, 3, 3,
            6, 6, 7, 8, 6, 1, 1, 1, 6, 4,
            4, 4, 6, 9, 7, 8, 8, 6, 1, 4,
            4, 7, 1, 8, 8, 6, 6, 6, 1, 1,
            1, 6, 6, 6, 7, 7, 8, 6, 6, 6,
            6, 8, 4, 1, 4, 7, 8, 8, 10
        ],
        [
            11, 9, 10, 10, 8, 7, 8, 3, 11, 12,
            7, 3, 3, 3, 9, 4, 11, 9, 6, 11,
            9, 14, 2, 3, 3, 3, 8, 8, 7, 6,
            4, 11, 6, 4, 11, 9, 9, 6, 13, 8,
            6, 7, 2, 9, 6, 8, 10, 9, 9, 2,
            4, 10, 4, 4, 6, 7, 9, 10, 11, 11,
            11, 8, 9, 6, 7, 9, 9, 3, 3, 3,
            8, 4, 4, 4, 13, 6, 7, 8, 10, 10,
            10, 6, 12, 3, 3, 7, 8, 11, 11, 11,
            4, 4, 4, 3, 3, 3, 6, 4, 4, 3,
            10, 7, 11, 10, 8, 6, 3, 7, 6, 7,
            8, 9, 10, 6, 7, 8, 6, 10, 10, 4,
            4, 3, 3, 3, 4, 2, 10, 8, 8, 10,
            10, 10, 6, 7, 9, 2, 10, 10, 8, 7,
            8, 3, 9, 7, 3, 3, 3, 2, 9, 9
        ],
        [
            11, 9, 10, 10, 8, 7, 8, 3, 11, 12,
            7, 3, 3, 3, 9, 4, 11, 9, 6, 11,
            9, 14, 2, 3, 3, 3, 8, 8, 7, 6,
            4, 11, 6, 4, 11, 9, 9, 6, 13, 8,
            6, 7, 2, 9, 6, 8, 10, 9, 9, 2,
            4, 10, 4, 4, 6, 7, 9, 10, 11, 11,
            11, 8, 9, 6, 7, 9, 9, 3, 3, 3,
            8, 4, 4, 4, 13, 6, 7, 8, 10, 10,
            10, 6, 12, 3, 3, 7, 8, 11, 11, 11,
            4, 4, 4, 3, 3, 3, 6, 4, 4, 3,
            10, 7, 11, 10, 8, 6, 3, 7, 6, 7,
            8, 9, 10, 6, 7, 8, 6, 10, 10, 4,
            4, 3, 3, 3, 4, 2, 10, 8, 8, 10,
            10, 10, 6, 7, 9, 2, 10, 10, 8, 7,
            8, 3, 9, 7, 3, 3, 3, 2, 9, 9
        ]
    ]
}
